// src/screens/ResponsibleGamingScreen.js
import React from 'react';
import {
  View,
  Text,
  TouchableOpacity,
  StyleSheet,
  ScrollView,
  Linking,
} from 'react-native';
import { StatusBar } from 'expo-status-bar';
import Header from '../components/Header';
import Footer from '../components/Footer';
import NavBar from '../components/NavBar';

export default function ResponsibleGamingScreen({ navigation }) {
  // Helper function to open external links
  const openLink = (url) => {
    Linking.openURL(url).catch((err) =>
      console.error("Couldn't load page", err)
    );
  };

  return (
    <View style={styles.outerContainer}>
      <Header navigation={navigation} />
      <ScrollView contentContainerStyle={styles.scrollContainer}>
        <Text style={styles.title}>Play Responsibly</Text>
        <Text style={styles.subtitle}>
          Your well-being is our priority. We are committed to providing a safe
          and fair environment for streaming and play.
        </Text>

        <View style={styles.contentBlock}>
          <Text style={styles.header}>Our Commitment to Fair Play</Text>
          <Text style={styles.bodyText}>
            CritCash is a streaming platform for gamers, and its events are decided by skill, never chance. We want every
            match to be fun, fair, and challenging. We encourage you to play
            within your personal limits and always for the enjoyment of the
            game.
          </Text>
        </View>

        <View style={styles.contentBlock}>
          {/* Since Terms v1.6 the $500 limit applies to unverified accounts only: a fraud control, not a spending tool, so it is not offered here. The support line stays. */}
          <Text style={styles.header}>Manage Your Play</Text>
          <Text style={styles.bodyText}>
            Maintaining control over your play is key to a positive experience.
            Super Crits, Rumbles and memberships are always optional, and you
            never need to buy anything to watch a live stream or to enter an
            event. For help taking a break, contact support@critcash.com.
          </Text>
        </View>

        <View style={styles.contentBlock}>
          <Text style={styles.header}>Know When to Take a Break</Text>
          <Text style={styles.bodyText}>
            If you find that streaming or competing is no longer fun or is causing you
            stress, it may be time to step back. Your participation should
            always be a positive and entertaining part of your life. If you feel
            the need to take a break, contact support@critcash.com.
          </Text>
        </View>

        <View style={styles.contentBlock}>
          <Text style={styles.header}>Need Support?</Text>
          <Text style={styles.bodyText}>
            If you are concerned about the amount of time or money you are
            spending on any online activity, or if you're worried about any
            compulsive behavior, confidential help is available.
          </Text>
          <TouchableOpacity
            onPress={() => openLink('https://www.samhsa.gov/find-help/national-helpline')}
          >
            <Text style={styles.link}>
              SAMHSA National Helpline: 1-800-662-4357
            </Text>
          </TouchableOpacity>
          <Text style={styles.bodyText}>
            SAMHSA provides free, confidential, 24/7 treatment referral and
            information for individuals and families facing mental health
            and/or substance use disorders.
          </Text>
        </View>

        <TouchableOpacity
          style={styles.button}
          onPress={() => (navigation.canGoBack() ? navigation.goBack() : navigation.navigate('Lobby'))}
        >
          <Text style={styles.buttonText}>← Go Back</Text>
        </TouchableOpacity>
      </ScrollView>
      <Footer navigation={navigation} />
      <NavBar navigation={navigation} />
      <StatusBar style="light" />
    </View>
  );
}

const styles = StyleSheet.create({
  outerContainer: {
    flex: 1,
    backgroundColor: '#000',
  },
  scrollContainer: {
    flexGrow: 1,
    alignItems: 'center',
    padding: 20,
    paddingBottom: 60, // Ensure space for the footer
  },
  title: {
    fontSize: 28,
    fontWeight: 'bold',
    color: '#FCD000',
    marginBottom: 10,
    textAlign: 'center',
  },
  subtitle: {
    fontSize: 16,
    color: '#CCC',
    textAlign: 'center',
    marginBottom: 30,
    paddingHorizontal: 10,
  },
  contentBlock: {
    width: '100%',
    backgroundColor: '#111',
    borderRadius: 8,
    padding: 15,
    marginBottom: 20,
  },
  header: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#FCD000',
    marginBottom: 10,
  },
  bodyText: {
    fontSize: 14,
    color: '#AAA',
    lineHeight: 22,
    marginBottom: 10,
  },
  listItem: {
    fontSize: 14,
    color: '#AAA',
    lineHeight: 22,
    marginLeft: 10,
  },
  link: {
    fontSize: 14,
    color: '#FCD000',
    textDecorationLine: 'underline',
    lineHeight: 22,
  },
  button: {
    marginTop: 20,
    backgroundColor: '#FCD000',
    paddingVertical: 12,
    paddingHorizontal: 30,
    borderRadius: 8,
    alignItems: 'center',
  },
  buttonText: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#000',
  },
});
